export const workspaceEndPoint = 'workspaces';
